import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChaseIqUpgradeTooltip from "../../../../shared/chaseIqUpgradeTooltip/ChaseIqUpgradeTooltip";
import { useChaseIqAccess } from "../../../../hooks/useChaseIqAccess";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/RiskMembersSagas";
import { VIEWS } from "../redux/RiskMembersReducer";

const OPTIONS = [
  { id: VIEWS.BY_VISITS, name: "Zero Visits" },
  { id: VIEWS.BY_PREDICTION, name: "Prediction" }
];

const ViewFilter = () => {
  const dispatch = useDispatch();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const view = useSelector((state) => state.riskMembers.view);
  const hasChaseIqAccess = useChaseIqAccess();

  const selected = OPTIONS.find((opt) => opt.id === view) || OPTIONS[0];

  return (
    <div id="risk-members-view-filter">
      <MultiSelectDropdown
        options={OPTIONS}
        selectedFilters={selected}
        placeholder="Select View"
        numberDisplayed={0}
        multiple={false}
        keepOpen={false}
        includeFilter={false}
        onSelectChange={(data) => {
          if (!data?.id || data.id === selected.id) return;
          if (!hasChaseIqAccess && data.id === VIEWS.BY_PREDICTION) {
            setTooltipOpen(true);
            return;
          }
          dispatch(actionCreators.setView(data.id));
        }}
      />
      {!hasChaseIqAccess && (
        <ChaseIqUpgradeTooltip
          anchorSelect="#risk-members-view-filter"
          isOpen={tooltipOpen}
          setIsOpen={setTooltipOpen}
        />
      )}
    </div>
  );
};

export default ViewFilter;
